import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Accesso effettuato"); nav("/admin"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "linear-gradient(135deg,#8F0C3B,#EA155B)" }}>
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8">
        <div className="text-center mb-6">
          <span className="text-3xl font-extrabold" style={{ fontFamily: "Outfit", color: "var(--sc-emerald)" }}>SENIOR<span style={{ color: "var(--sc-amber)" }}>CAR</span></span>
          <p className="text-slate-500 mt-2">Area riservata · CMS & CRM</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="text-sm font-semibold text-slate-700">Email</label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 mt-1" data-testid="login-email" required /></div>
          <div><label className="text-sm font-semibold text-slate-700">Password</label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 mt-1" data-testid="login-password" required /></div>
          <Button type="submit" disabled={loading} className="w-full h-12 font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid="login-submit">{loading ? "Accesso..." : "Accedi"}</Button>
          <div className="text-center"><Link to="/forgot-password" className="text-sm text-emerald-800 hover:underline" data-testid="forgot-link">Password dimenticata?</Link></div>
        </form>
      </div>
    </div>
  );
}
